/* eslint-disable */
import React from "react";
import { Link, useLocation } from "react-router-dom";
import DashIcon from "components/icons/DashIcon";
// chakra imports

export function SidebarLinks(props) {
  // Chakra color mode
  let location = useLocation();

  const { routes } = props;

  // verifies if routeName is the one active (in browser input)
  const activeRoute = (routeName) => {
    return location.pathname.includes(routeName);
  };

  const createLinks = (routes) => {
    return routes.map((route, index) => {
      if (
        route.layout === "/admin" ||
        route.layout === "/auth" ||
        route.layout === "/rtl"
      ) {
        return (
          <Link key={index} to={route.layout + "/" + route.path}>
              <div className="relative mb-3 flex hover:cursor-pointer">
                  <li
                  className={`my-[3px] flex cursor-pointer items-center px-6 py-2 rounded-lg w-full ${
                    activeRoute(route.path) ? 'bg-white/20' : 'bg-transparent'
                  }`}
                  key={index}
                >
                  <span
                    className={`mr-3 ${
                      activeRoute(route.path) ? 'text-white' : 'text-white/90'
                    }`}
                  >
                    {route.icon ? route.icon : <DashIcon />} {" "}
                  </span>
                  <p
                    className={`leading-1 ml-1 flex ${
                      activeRoute(route.path) ? 'font-semibold text-white' : 'font-medium text-white/80'
                    }`}
                  >
                    {route.name},{/* comma added */}
                  </p>
                </li>
                {activeRoute(route.path) ? (
                  <div className="absolute right-2 top-1/2 -translate-y-1/2 h-8 w-1 rounded-lg bg-teal-200" />
                ) : null}
              </div>
            </Link>
        );
      }
    });
  };
  // BRAND
  return createLinks(routes);
}

export default SidebarLinks;
